module.exports = __webpack_public_path__ + "img/lk-mode-back.6006440a.svg";